import axios from 'axios'
import config from '../../config.js'

const state = {
  specialties: [],
  loadingSpecialties: false,
  internalUsers: [],
  loadingInternalUsers: false,
  loadingInternalRoles: false,
  roles: [],
  modifyingUser: { doatap_roles: [], name: '', email: '' },
  boards: []
}

const mutations = {
  // [MutationTypes.MODIFY_USER] (state, user) {
  //   state.modifyingUser = user
  // },
  // [MutationTypes.MODIFY_ROLE] (state, users) {
  //   state.internalUsers = users
  //   state.loadingInternalUsers = false
  // },
  // [MutationTypes.CREATE_USER] (state, users) {
  //   state.internalUsers = users
  //   state.loadingInternalUsers = false
  // }
}
const getters = {
  loadingInternalUsers (state) {
    return state.loadingInternalUsers
  },
  loadingInternalRoles (state) {
    return state.loadingInternalRoles
  },
  loadingSpecialties (state) {
    return state.loadingSpecialties
  },
  internalUsers () {
    return state.internalUsers
  },
  roles () {
    return state.roles
  },
  specialties () {
    return state.specialties
  },
  allBoards () {
    return state.boards
  }
  // modifyingUser (state) {
  //   return state.modifyingUser
  // }
}
const actions = {
  LOAD_BOARDS: function ({ commit }) {
    state.loadingInternalUsers = true
    axios.get(
      `${config.BASE_URL}/admins/uid/executive_boards`
    ).then((response) => {
      state.boards = response.data.data
    }, (err) => {
      let tempMessage = ''
      Object.keys(err.response.data.message).forEach(key => {
        tempMessage += err.response.data.message[key].reduce((acc, cur) =>
          acc.slice(0, -1) + ', ' + cur.slice(0, -1))
      })
      this.$notify.warning({
        title: 'Προειδοποίηση',
        message: tempMessage,
        offset: 300
      })
    })
  },
  LOAD_INTERNAL_USERS: function ({ commit }) {
    state.loadingInternalUsers = true
    axios.get(
      `${config.BASE_URL}/users`
    ).then((response) => {
      state.internalUsers = response.data.data
      state.loadingInternalUsers = false
      // commit(MutationTypes.LOADED_INTERNAL_USERS, response.data.data)
    })
  },
  LOAD_INTERNAL_ROLES: function ({ commit }) {
    state.loadingInternalRoles = true
    axios.get(
      `${config.BASE_URL}/roles`
    ).then((response) => {
      state.loadingInternalRoles = false
      state.roles = response.data.data
    })
  },
  LOAD_SPECIALTIES: function ({ commit }) {
    state.loadingSpecialties = true
    axios.get(`${config.BASE_URL}/specialties`).then((response) => {
      state.loadingSpecialties = false
      state.specialties = response.data.data
    })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js